import { Group, Text, Image } from "@mantine/core";

import classes from "./Logo.module.css";

interface LogoProps {
  logo?: string;
  name?: string;
}

// Defaults come from public/logo192.png rather than a bundled media file: that is the
// asset the favicon and the manifest already use, and the one the other storefronts
// load for this app in their switcher, so there is a single picture to replace.
// (This component used to hardcode ACC DRIVE's logo and name.)
export default function Logo({
  logo = `${process.env.PUBLIC_URL}/logo192.png`,
  name = "ACE DRIVE",
}: LogoProps): React.JSX.Element {
  return (
    <Group className={classes.logo}>
      <Image radius="md" h={40} w={40} src={logo} />
      <Text fs="italic" size="xl">
        {name}
      </Text>
    </Group>
  );
}
